import React, { useEffect } from 'react';
import { routes } from 'Utility/constants';
import * as actions from 'redux/actions/index';
import { connect, useDispatch } from 'react-redux';
import Loader from 'react-loader-spinner';

const HomeSub = (props) => {
   const dispatch = useDispatch();
   let plan = [];
   let trialPeriod, text;

   useEffect(() => {
      dispatch(actions.plans());
   }, [dispatch]);

   if (props.plans) {
      plan = props.plans.plans;
   }

   if (props.user && props.user.has_trial === true) {
      trialPeriod = 'Subscribe now to get 14 days of free access!';
      text = 'after trial ends';
   } else {
      trialPeriod = null;
      text = null;
   }

   return (
      <div id="wrap">
         <section className="ihWeb_sec theme_nav_mt">
            <div className="container">
               <div className="row">
                  <div className="col-sm-12 mx-auto">
                     <div
                        className="ihWeb_bgSh ihWeb_bgSh_subscrbe hero_props"
                        style={{
                           backgroundImage: `url(${require('assets/images/background/hero-bg1.png')})`,
                        }}
                     >
                        <article className="ihWeb_art text-center">
                           <h2>
                              {' '}
                              <span className="text-uppercase">
                                 Subscribe
                              </span>{' '}
                              for
                              <br /> Technology to Optimize Your Meditation{' '}
                           </h2>
                        </article>
                        <form>
                           <ul className="ihWeb_2clm">
                              {plan && plan.length > 0 ? (
                                 plan.map((nplan) => {
                                    let amount = `$${nplan.amount / 100}/${nplan.interval
                                       }`;

                                    return (
                                       <li>
                                          <div
                                             style={{ cursor: 'pointer' }}
                                             className="fields_wrp"
                                             onClick={() => {
                                                dispatch(
                                                   actions.planid(nplan.id)
                                                );
                                                dispatch(
                                                   actions.planName(
                                                      nplan.nickname
                                                   )
                                                );
                                                dispatch(
                                                   actions.planPrice(amount)
                                                );
                                                props.history.push(
                                                   routes.PAYMENT
                                                );
                                             }}
                                          >
                                             <h4>{nplan.nickname}</h4>
                                             <h4 class="mb-0">
                                                {amount} {text}
                                             </h4>
                                          </div>
                                       </li>
                                    );
                                 })
                              ) : (
                                    <Loader
                                       type="Circles"
                                       color="#FFF"
                                       height={25}
                                       width={110}
                                    />
                                 )}
                           </ul>
                        </form>
                        <br />
                        <h2 style={{ color: 'white', textAlign: 'center' }}>
                           <span>{trialPeriod}</span>
                        </h2>
                     </div>
                  </div>
               </div>
            </div>
         </section>
         <section class="para_sec">
            <div class="container">
               <div class="row">
                  <div class="col-sm-12">
                     <article class="ihWeb_art text-center ihWeb_bgSh_art site_heading">
                        <h2 class="text_tertiary">
                           How it Works
                           <br /> Technology to Optimize Your Meditation:
                        </h2>
                        <div class="tech_para">
                           <p>
                              Combining Meditation, Frequency, Vibration &
                              Technology to Optimize Human Potential. Step into
                              the world of sound and frequency assisted
                              meditation and mindfulness. Let's get inHarmony
                              with the world around us. The benefits of being
                              inHarmony are broad and comprehensive. Take
                              control and make an impact on your:
                           </p>
                           <p>
                              Focus & mental clarity
                              <br />
                              Anxiety & Stress
                              <br />
                              Sleep & mood
                              <br />
                              Muscle tension & chronic ailments
                           </p>
                           <p>
                              #TogetherWeCan. Join our growing community of
                              incredible humans on a quest to improve our
                              overall health and well being. inHarmony
                              Interactive brings together years of science and
                              research in sound, frequency, vibration,
                              meditation, breath work, mindfulness, optimal
                              human performance, rejuvenation and longevity.
                              Within our app, you will discover beautiful sound
                              experienced designed to take your mind and body to
                              new heights. We're excited to have you with us.
                              We're excited for you to contribute to our
                              community. Grow with us. See you soon.
                           </p>
                        </div>
                     </article>
                  </div>
               </div>
            </div>
         </section>
      </div>
   );
};

const mapStateToProps = (state) => {
   return {
      plans: state.authReducer.plans,
      successAPI: state.authReducer.successAPI,
      user: state.authReducer.user,
      planName: state.authReducer.planName,
      planid: state.authReducer.planid,
   };
};

export default connect(mapStateToProps)(HomeSub);
